import { PERMISSIONS, terraContract } from '@terra/shared-authorization';
import { z } from 'zod';
import { ApplicationsIdSchema } from '../applications.schema';
import {
  FullRescanRunSchema,
  LatestFullRescanResponseSchema,
} from './full-rescan.schema';

export const fullRescanContractRoutes = {
  startApplicationFullRescan: terraContract
    .meta({
      permissions: [PERMISSIONS.EXECUTE_FULL_RESCAN.name],
    })
    .route({
      method: 'POST',
      path: '/{id}/full-rescan',
      summary: 'Start a full rescan of an application',
      description:
        'Recrawls the application, reruns feature analysis and signal checks, regenerates code graphs and security test cases, starts a deep scan, and re-executes blocked signals. Per-application generation limits are lifted while the rescan is active. Consumes a large amount of AI capacity.',
      inputStructure: 'detailed',
    })
    .input(z.object({ params: ApplicationsIdSchema }))
    .output(FullRescanRunSchema),
  getLatestApplicationFullRescan: terraContract
    .meta({
      permissions: [PERMISSIONS.VIEW_APPLICATIONS.name],
    })
    .route({
      method: 'GET',
      path: '/{id}/full-rescan/latest',
      summary: 'Get the latest full rescan of an application',
      description:
        'Returns the most recent full rescan with its step results and how its findings compare with findings that existed before it started.',
      inputStructure: 'detailed',
    })
    .input(z.object({ params: ApplicationsIdSchema }))
    .output(LatestFullRescanResponseSchema),
};
